import { useState, useEffect } from "react";
import Header from "layout/Header";
import "./index.css";
import Main from "layout/Main";
import Footer from "layout/Footer";
import Loading from "./components/Loading";
import ReactGA from "react-ga";
import i18n from "i18n";

ReactGA.initialize("UA-214554139-1");

const MAX_LOADING = 0;
let currentLoad = 0;
let time = null;

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const [percent, setPercent] = useState(0);
  const [story, setStory] = useState(false);
  const [hiddenHeader, setHiddenHeader] = useState(false);
  const [language, setLanguage] = useState(i18n.language);

  function increaseLoading() {
    currentLoad++;
  }
  useEffect(() => {
    time = setInterval(() => {
      let percent = currentLoad / MAX_LOADING;
      setPercent(percent);
      if (percent === 1) {
        clearInterval(time);
        time = null;
      }
    }, 500);
  }, []);

  const [selectedData, setSelectedData] = useState({});

  return (
    <>
      {percent < 1 && <Loading percent={percent} />}
      <div className="relative w-full overflow-x-hidden">
        <div className="flex flex-col mx-auto">
          <div className="w-full flex justify-center">
            {!hiddenHeader && (
              <Header
                onScrollStory={(sr) => {
                  setStory(sr);
                }}
                language={language}
                setLanguage={setLanguage}
              />
            )}
          </div>

          <Main
            increaseLoading={increaseLoading}
            showStory={story}
            setHiddenHeader={setHiddenHeader}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            language={language}
          />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
